
import { defineComponent, ref } from "vue";
import { useRoute } from "vue-router";

import { PageInterface, createNewPage } from "../models/Page.interface";
import { pageStoreTypes } from "../store/types";
import { useAntaresConfig } from "@/core/modules/config";
import { useAntaresLocale } from "@/core/modules/locale";
import { usePageStore } from "../store";

export default defineComponent({
  name: "Page",
  setup() {
    const { t } = useAntaresLocale();
    const route = useRoute();
    const antaresConfig = useAntaresConfig();

    const pageStore = usePageStore();
    const record = ref(createNewPage());
    record.value.slugIt = route.params.slug as string;

    const loadAction = async () => {
      record.value = (await pageStore.action(pageStoreTypes.actions.getPage, record.value.slugIt)) as PageInterface;
      // TODO handle error if not present
    };

    loadAction();

    return {
      antaresConfig,
      record,
      t,
    };
  },
});
